import { Navigate, useLocation } from 'react-router-dom';
import { checkAnyPermission, checkPermission } from '../../hooks/usePermissions';
import { isActingAs } from '../../auth/authUtils';

// CRM tabs with their permissions — used for smart redirect
const CRM_TABS = [
  { path: '/my/crm', perm: 'view_dashboard' },
  { path: '/my/crm/fans', perm: 'view_fans' },
  { path: '/my/crm/scripts', perm: 'manage_scripts' },
  { path: '/my/crm/automations', perm: 'manage_automations' },
  { path: '/my/crm/vault', perm: 'manage_crm_vault' },
  { path: '/my/crm/team', perm: 'manage_team' },
  { path: '/my/crm/analytics', perm: 'view_analytics' },
  { path: '/my/crm/insights', perm: 'view_insights' },
];

/**
 * Route guard that checks team permissions.
 * If the user is acting as a creator (delegated access), checks they have
 * at least one of the required permissions. Own account users pass through.
 */
const PermissionRoute = ({ children, perms = [] }) => {
  const location = useLocation();

  // Not acting as anyone — own account, full access
  if (!isActingAs()) return children;

  // No specific permissions required
  if (perms.length === 0) return children;

  // Check permissions
  if (!checkAnyPermission(...perms)) {
    // Find the first CRM tab they have access to (avoid redirect loop)
    const isCrmRoute = location.pathname.startsWith('/my/crm');
    if (isCrmRoute) {
      const firstAllowed = CRM_TABS.find(tab => tab.path !== location.pathname && checkPermission(tab.perm));
      return <Navigate to={firstAllowed?.path || '/home'} replace />;
    }
    return <Navigate to="/home" replace />;
  }

  return children;
};

export default PermissionRoute;
